"use strict";
import React, { createRef, Component } from "react";
import classNames from "classnames";
import { handleMouseUpByBlurring } from "../../../utils/focus";
import { TabsContext } from "./Tabs";
class Tab extends Component {
  constructor() {
    super(...arguments);
    this.tabRef = createRef();
  }
  componentDidMount() {
    this.context.addTabRef(this.tabRef, this.props.index);
  }
  componentWillUnmount() {
    this.context.removeTabRef(this.tabRef);
  }
  render() {
    const { index, children, className, onClick } = this.props;
    const { selectedIndex, setSelectedIndex, id } = this.context;
    const isSelected = selectedIndex === this.props.index;
    const handleClick = (event) => {
      onClick == null ? void 0 : onClick(event);
      setSelectedIndex(index);
    };
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: classNames("tabs__tab", className),
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": `tabs-${id}-panel-${index}`,
        id: `tabs-${id}-tab-${index}`,
        onClick: handleClick,
        onMouseUp: handleMouseUpByBlurring,
        tabIndex: isSelected ? 0 : -1,
        ref: this.tabRef,
        type: "button"
      },
      children
    );
  }
}
Tab.contextType = TabsContext;
export default Tab;
